var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',_vm._b({},'b-row',{ id: _vm.id },false),[_c('WidgetGroup',{attrs:{"widgets":_vm.childrenSlots.default}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }